/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  createContext,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import useSetState from 'hooks/useSetState';
import isIE from 'services/isIE';
import { interactionContext } from './interactionContext';
import InputText from 'components/UI/InputText';
import { setCMIInteractionsMultichoice } from 'services/scorm/scormService';
import Id_ from './Message';
import collectFeedbackSubmitted from 'assets/collectFeedbackSubmitted.svg';

const FiveStarRatingContext = createContext(undefined);

const FeedbackSubmitted = () => {
  return (
    <div
      className="fader_-5s"
      css={css`
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      `}
    >
      <img src={collectFeedbackSubmitted} />
      <div
        css={css`
          margin: 50px 0 0 0;
          font-size: 18px;
          text-align: center;
        `}
      >
        Thanks! Your feedback has been submitted.
      </div>
    </div>
  );
};

const FiveStarRating = props => {
  const { children } = props;
  let [FiveStarList, Message, SubmitBtn] = children;

  const {
    useMyFeedbackApp = 0,
    emailRequired = 1,
    emailOptional = 0,
    anonymityRequired = 0,
    identityPlaceholder,
  } = useContext(interactionContext).props;

  const {
    state: { rating, learnerIdentity, message },
    setState,
  } = useSetState({
    rating: null,
    learnerIdentity: '',
    message: '',
  });

  // const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  // let hasEmail = false;
  let hasLearnerIdentity = learnerIdentity !== '';
  // if (emailRequired === 0) {
  //   hasLearnerIdentity = true;
  // } else {
  //   if (learnerIdentity.includes('@')) {
  //     hasLearnerIdentity = true;
  //   }
  // }

  const Id =
    !!useMyFeedbackApp && (!!emailRequired || !!emailOptional) ? (
      <Id_
        placeholder={identityPlaceholder || 'Enter your id'}
        onUpdateCallback="onUpdateLearnerIdentity"
        style={{ height: 45, margin: '0 0 10px 0', overflow: 'hidden' }}
      />
    ) : null;

  Message = React.cloneElement(Message, {
    onUpdateCallback: 'onUpdateMessage',
    style: {
      minHeight: 150,
      margin: '10px 0 30px 0',
    },
  });

  return (
    <FiveStarRatingContext.Provider
      value={{
        rating,
        message,
        hasLearnerIdentity,
        learnerIdentity,
        onSubmit() {
          setSubmitted(true);
        },
        alertLearnerIdentity() {
          // console.log()
        },
        onUpdateRating(index) {
          setState({ rating: index === rating ? null : index });
        },
        onUpdateLearnerIdentity(learnerIdentity) {
          // console.log(learnerIdentity);
          setState({ learnerIdentity });
        },
        onUpdateMessage(message) {
          // console.log(message);
          setState({ message });
        },
      }}
    >
      {/* {!!useMyFeedbackApp && (!!emailRequired || !!emailOptional) && (
        <div
          css={css`
            width: 100%;
          `}
        >
          <InputText
            placeholder="Enter your email"
            defaultValue={email}
            onUpdate={$ => {
              setEmail($);
            }}
            onEnter={$ => null}
            css={css`
              font-size: 16px;
            `}
          />
        </div>
      )} */}
      {/* {isIE() ? (
        <div
          css={css`
            width: 100%;
          `}
        >
          {FiveStarList}
          {Id}
          {Message}
          {SubmitBtn}
        </div>
      ) : (
        <_>
          {FiveStarList}
          {Id}
          {Message}
          {SubmitBtn}
        </_>
      )} */}

      <div
        css={css`
          display: flex;
          align-items: center;
          position: relative;
          width: 100%;
          height: 100%;
        `}
      >
        <div
          css={css`
            width: 100%;
            height: 100%;
            opacity: 1;
            ${submitted &&
              `
            opacity: 0;
            transition: opacity 0.3s;
            `}
          `}
        >
          {FiveStarList}
          {Id}
          {Message}
          {SubmitBtn}
        </div>

        {submitted && <FeedbackSubmitted />}
      </div>
    </FiveStarRatingContext.Provider>
  );
};

export default FiveStarRating;
export { FiveStarRatingContext };
